module.exports = __webpack_public_path__ + "img/xhs.23480ab7.png";